import { Box, Container } from "@mui/material";
import MetaTags from "react-meta-tags";

import { HeroText } from "components/shared/Typography";
import { REGISTER_TITLE, REGISTER_LINK_CANONICAL } from "helpers/metatags";

import RegisterForm from "components/auth/RegisterForm";

const Register = () => {
  return (
    <Box width={1}>
      <MetaTags>
        <title>{REGISTER_TITLE}</title>
        <link rel="canonical" href={REGISTER_LINK_CANONICAL} />
      </MetaTags>
      <Container>
        <Box px={{ xs: 0, sm: 3 }} pt={{ xs: 3, md: 4, lg: 5 }}>
          <HeroText letterSpacing={0.25}>Welcome to Assay Marketplace</HeroText>
        </Box>
        <Box
          px={{ xs: 0, sm: 3 }}
          pt={{ xs: 6, sm: 6, md: 7, lg: 8 }}
          pb={{ xs: 8, sm: 9, md: 8, lg: 11 }}
        >
          <RegisterForm />
        </Box>
      </Container>
    </Box>
  );
};

export default Register;
